import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

export async function refreshToken() {
  try {
    const refresh = localStorage.getItem("refresh_token");
    const res = await axios.post(`${API_URL}/api/auth/refresh/`, {
      refresh,
    });
    localStorage.setItem("access_token", res.data.access);
    return res.data.access;
  } catch (err) {
    console.error("Refresh failed", err);
    return null;
  }
}